<template>
  <div class="statistics-body">
    <a-drawer
      title="Total no. of Assessors, Not Submitted"
      placement="right"
      width="600"
      :visible="visible"
      :bodyStyle="{ height: 'calc(100% - 90px' }"
      @close="onClose"
    >
      <div class="statistics-info">
        <span
          >Not Submitted: <b class="statistics-num">{{ data.length }}</b></span
        >
        <span class="selected"
          >Selected:
          <b class="statistics-num">{{ selectedRows.length }}</b></span
        >
      </div>
      <a-table
        :rowSelection="rowSelection"
        :columns="columns"
        :data-source="data"
        :pagination="false"
        :scroll="{ y: '95%' }"
        style="height: calc(100% - 132px)"
      >
        <span slot="action" slot-scope="record">
          <my-tooltip :tooltip="$t('_components.btns.send')">
            <img
              class="cur"
              src="@/assets/images/icons/Vector.svg"
              mode="scaleToFill"
              @click="sendTodo(record)"
            />
        </my-tooltip>
        </span>
      </a-table>
      <div class="statistics-btn">
        <a-button @click="onClose" class="btn-cancel">{{ $t('_components.btns.cancel') }}</a-button>
        <a-button type="primary" @click="sendTodoAll" class="btn-last" :disabled="selectedRowKeys.length === 0"
        :loading="loading">{{ $t('_components.btns.send') }}</a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import performanceAPI from '@/api/staff/performance';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      a: 1,
      columns: [
        { title: 'Code', dataIndex: 'code', key: 'code' },
        { title: 'Name', dataIndex: 'name', key: 'name' },
        { title: 'Last Sent', dataIndex: 'laseSend', key: 'laseSend' },
        {
          title: 'Action',
          key: 'operation',
          width: 100,
          scopedSlots: { customRender: 'action' },
        },
      ],
      selectedRows: [],
      selectedRowKeys: [],
      loading: false,
    };
  },

  created() {
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          // console.log(
          //   `selectedRowKeys: ${selectedRowKeys}`,
          //   'selectedRows: ',
          //   selectedRows,
          // );
          this.selectedRows = selectedRows;
          this.selectedRowKeys = selectedRowKeys;
        },
        selectedRowKeys: this.selectedRowKeys,
      };
    },
  },
  methods: {
    onClose() {
      this.$emit('update:visible', false);
    },
    sendTodo(e) {
      performanceAPI.triggerSendNotice({ userIds: e.key }).then(res => {
        if (res.data.code === 200) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: res.data.msg,
              variant: 'warning',
            },
          })
        }
      })
    },
    sendTodoAll() {
      if (this.selectedRows.length === 0) {
        return;
      }
      this.loading = true;
      performanceAPI.triggerSendNotice({ userIds: this.selectedRowKeys.toString() }).then(res => {
        this.selectedRowKeys = [];
        if (res.data.code === 200) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: res.data.msg,
              variant: 'warning',
            },
          })
        }
      })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.statistics-info {
  font-size: 16px;
  padding-bottom: 16px;
  .selected {
    margin-left: 48px;
  }
}
.cur {
  cursor: pointer;
}
.statistics-btn {
  position: absolute;
  bottom: 24px;
  left: 0;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  .btn-last {
    margin-left: 32px;
  }
}
</style>

<style lang="scss">
.ant-drawer-header {
  padding: 33.5px 24px;
  .ant-drawer-title {
    font-size: 22px;
  }
  .ant-drawer-close {
    top: 14px;
  }
}
.ant-drawer-body {
  padding: 16px 20px;
  position: relative;
  .ant-spin-nested-loading,
  .ant-spin-container,
  .ant-table,
  .ant-table-content,
  .ant-table-scroll {
    height: 100%;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: rgba(115, 103, 240, 1);
    border-color: rgba(115, 103, 240, 1);
  }
  .ant-table-thead > tr > th .ant-table-header-column {
    font-weight: 700;
  }
  .ant-table-thead > tr > th {
    padding: 6px 16px;
  }
}
.ant-btn {
  width: 94px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border-color: rgba(115, 103, 240, 1);
}
.btn-cancel {
  .ant-btn:focus, .ant-btn:hover{
    color: rgba(115, 103, 240, 1);
  }
}
.ant-btn-primary, .ant-checkbox-indeterminate .ant-checkbox-inner:after{
  background-color: rgba(115, 103, 240, 1);
}
.ant-btn-primary[disabled]{
  color: rgba(0, 0, 0, .25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}
</style>
